import $ from 'jquery';
import { capFirst } from '../utilities.js';
import { updateTotalPrice } from './showroom-utilities.js';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
import PaymentCalculatorForm from '../components/payment-calc/payment-calculator.js';
import MicroModal from 'micromodal';


// Cash Incentives

const summaryBreakdown = $('.summary-cash-breakdown');

const formPrice = $('.bottom-form .dsp_dynamic_price input');

const bottomBarTotals = {
  'cash': $('.summary-cash-breakdown .bottom-bar--total'),
  'finance': $('.summary-finance-breakdown .js-summary-total-price'),
  'lease': $('.summary-lease-breakdown .js-summary-total-price'),
}
const configuredTotal = summaryBreakdown.data('configured');

$('.summary-cash-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['cash'], 'cash', formPrice);
});
$('.summary-finance-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['finance'], 'finance', formPrice);
});
$('.summary-lease-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['lease'], 'lease', formPrice);
});



// Lease/Finance Calculator
const $summaryModal = $('#modal-summary-payments');

const MULTIPLIERS = {
  Weekly: 52, // payment per year
  'Bi-Weekly': 26, // payments per year
  Monthly: 12, // payments per year
};

$('.js-open-summary-payment').on('click', function () {

  const type = $(this).data('type');
  
  $summaryModal.find('.payment-title').each(function () {
    $(this).text(capFirst(type));
  });

  // exclusive sections - show only the section of specified type
  $summaryModal.find(`.js-exclusive-visible`).addClass('hidden');
  $summaryModal.find(`.js-exclusive-visible.summary-${type}`).removeClass('hidden');

  const formOption = $('.summary-form').find(`option[value=${capFirst(type)}]`);

  const selectOption = formOption.parents('select');

  // toggle payment calculator to specified type
  $(`#show-${type}-info`).trigger('click');

  MicroModal.show('modal-summary-payments');

  selectOption.val(capFirst(type)).change();


});


$('.term-dropdown').on('change', function () {
  const type = $(this).data('type');
  const rate = $(this).find(':selected').data('rate');
  const term = $(this).find(':selected').data('term');

  updateCount(type, term);
  $(`.js-summary-${type}-period`).text(term);
  $(`.js-summary-${type}-rate`).text(Formatter.number(rate, 2));

  if (type == 'lease') {
    const residual = $(this).find(':selected').data('residual');
    $(`.js-summary-${type}-residual`).text(Formatter.price(residual));
  }
});

$('.summary-payment').each(function () {
  const type = $(this).data('type');
  let calcInputs = {
    price: $(this).data('price'),
    down: 0,
    term: $(this).data('term'),
    rate: $(this).data('rate'),
    tradein: 0,
    tax: 0,
  };

  if (type === 'lease') {
    calcInputs.residual = $(this).data('residual');
  }

  const financeCalc = PaymentCalculatorFactory.createCalculator(type, calcInputs);

  financeCalc.calculate();
  $(this).text(Formatter.price(financeCalc.payments.biweekly, 0));
});

$('.payment-frequency-button').on('change', function () {
  const frequency = $(this).siblings('label').text().trim();
  ['lease', 'finance'].forEach(function (type) {
    const term = $(`#js-calc-small-${type}-term`).find(':selected').data('term');
    updateCount(type, term, frequency);
  });
});

function updateCount(type, term, frequency = null) {

  const frequencyText = frequency ?? $(`.js-summary-${type}-frequency`).text().trim();

  const count = term * MULTIPLIERS[frequencyText];


  $(`.js-summary-${type}-count`).text(Formatter.number(count, 0));
  $(`.js-summary-${type}-frequency`).text(frequencyText);
}

const paymentCalculatorForm = new PaymentCalculatorForm('js-calc-small-form');
